import api from './api';

export function getMeansOfDisbursementById(idCredit) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/${idCredit}/disbursement-mean`);
}

export function meansOfDisbursementRegister(data) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/${data.idCredito}/${data.subCanal}/disbursement-mean`, data);
}
